import { render, staticRenderFns } from "./narratorUpdate.vue?vue&type=template&id=cbedac38&"
import script from "./narratorUpdate.vue?vue&type=script&lang=js&"
export * from "./narratorUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports